<template>
    <div style="text-align: left">
        <div class="herd">
            <div class="list">统计分析</div>
            <div style="margin-right: 20px;">
                <el-select v-model="timeSectionState" @change="getTitleQuota" placeholder="请选择">
                    <el-option label="最近三个月" value="1"></el-option>
                    <el-option label="最近半年" value="2"></el-option>
                    <el-option label="最近一年" value="3"></el-option>
                </el-select>
            </div>
        </div>

        <div class="content">
            <div class="goods">
                <div>
                    <div class="condition">
                        学校名称：<el-input placeholder="请输入学校名称" v-model.trim="info.schoolName" class="input-with-select"
                            style="max-width: 200px">
                        </el-input>&nbsp;&nbsp;
                        地区：<el-cascader placeholder="请选择地区"
                            :props="{ label: 'areaName', value: 'areaName', children: 'childList' }" :options="options"
                            v-model="info.detailedArea" filterable change-on-select></el-cascader>
                        <el-button style="margin-left:20px" type="primary" plain @click="search">搜 索</el-button>
                        <el-button style="margin-left:20px" type="primary" @click="resetList" plain>重 置</el-button>
                        <el-button style="margin-left:20px" type="primary" @click="openFinancial" plain>财务导出</el-button>
                        <el-button style="margin-left:20px" type="primary" @click="openInChargen" plain>负责人</el-button>
                    </div>
                    <hr style="margin-top: 20px" />
                    <div style="margin-top: 20px;display: flex;justify-content: space-between;">
                        <div class="gross-container" style="background-color: #67B8F0;">
                            <p style="font-size: 25px;">{{ statisticsData.ownGoodsSaleroom }}</p>
                            <p style="font-size: 10px; margin-top: 10px;">总流水(元)</p>
                        </div>
                        <div class="gross-container" style="background-color: #67B8F0;">
                            <p style="font-size: 25px;">{{ statisticsData.totalFlow }}</p>
                            <p style="font-size: 10px; margin-top: 10px;">自有商品销售额(元)</p>
                        </div>
                        <div class="gross-container" style="background-color: #67B8F0;">
                            <p style="font-size: 25px;">{{ statisticsData.recommendGoodsSaleroom }}</p>
                            <p style="font-size: 10px; margin-top: 10px;">推荐商品销售额(元)</p>
                        </div>
                        <div class="gross-container" style="background-color: #67B8F0;">
                            <p style="font-size: 25px;">{{ statisticsData.freightSum }}</p>
                            <p style="font-size: 10px; margin-top: 10px;">总运费(元)</p>
                        </div>
                    </div>
                </div>
                <br />
            </div>
            <br />
            <!-- <div @click="export2Excel">导出表格</div> -->
            <div class="global-table-box">
                <el-table :data="tableData" border style="width: 100%;" tooltip-effect="dark" :cell-style="{}">
                    <!-- <el-table-column type="selection" width="55">
                    </el-table-column> -->
                    <el-table-column type="index" width="50" label="#" header-align="center" align="center">
                    </el-table-column>
                    <el-table-column prop="schoolName" label="学校名称" width="270" header-align="center">
                    </el-table-column>
                    <el-table-column label="自有商品销售额(元)" prop="ownGoods" width="200" align="center" header-align="center"
                        max-width="500px">
                    </el-table-column>
                    <el-table-column prop="transportation" label="运输费用(元)" width="200" align="center" header-align="center"
                        max-width="500px">
                    </el-table-column>
                    <el-table-column label="销售总额(元)" width="200" header-align="center" align="center">
                        <template slot-scope="scope">
                            {{ totalCalculation(scope.row) }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="ownGoodsCount" label="销售数量" width="200" header-align="center" align="center">
                    </el-table-column>
                    <el-table-column label="操作" header-align="center" align="center">
                        <template slot-scope="scope">
                            <el-button @click="export2Excel(scope.row)" type="text" size="small">导出数据</el-button>
                            <el-button type="text" size="small" @click="editorChild(scope.row)">详情</el-button>
                            <!-- <el-button @click="deleteGoodsOne(scope.row)" type="text" size="small">删除</el-button> -->
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="block">
                <!-- <el-pagination @size-change="handleCurrentChange" :current-page="info.pageNum"
                    layout="prev, pager, next, jumper" :total="totalPage" :page-size="10">
                </el-pagination> -->
                <el-pagination @current-change="handleCurrentChange" :current-page.sync="info.pageNum" :page-size="10"
                    layout="prev, pager, next, jumper" :total="totalPage">
                </el-pagination>
            </div>
        </div>


        <!-- 财务导出表 -->
        <el-dialog title="财务导出" :visible.sync="dialogRefundExpoit" width="400px">
            <el-form :model="infoExpoit" :rules="rules" ref="infoExpoit" label-width="100px" class="demo-ruleForm">
                <el-form-item label="开始时间" prop="startTime">
                    <el-date-picker value-format="yyyy-MM-dd HH:mm:ss" format="yyyy-MM-dd HH:mm:ss" type="datetime"
                        v-model="infoExpoit.startTime" placeholder="选择日期时间">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="结束时间" prop="endTime">
                    <el-date-picker value-format="yyyy-MM-dd HH:mm:ss" format="yyyy-MM-dd HH:mm:ss" type="datetime"
                        v-model="infoExpoit.endTime" placeholder="选择日期时间">
                    </el-date-picker>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogRefundExpoit = false">取 消</el-button>
                <el-button type="primary" @click="financialExport">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import request from '../utils/request';
import axios from 'axios';
import exportUrl from '../Api/exportUrl'
export default {

    data() {
        return {
            exportUrl,
            // 查询参数
            info: {
                province: null,
                city: null,
                area: null,
                isPage: true,
                pageSize: 10,
                pageNum: 1,
                schoolName: '',
                detailedArea: []
            },
            dataList: [
            ],
            // 查询时间
            timeSectionState: "1", // 1 近三月 2 近半年 3 近一年
            // 指标数据
            statisticsData: {},
            // 地址
            options: [],
            // 学校列表
            tableData: [],
            // 总条数
            totalPage: 0,
            // 导出参数
            infoExpoit: {
                endTime: '',
                startTime: ''
            },
            // 导出弹窗
            dialogRefundExpoit: false,
            // 财务导出校验
            rules: {
                startTime: [
                    { required: true, message: '请选择开始时间', trigger: 'blur' },
                ],
                endTime: [
                    { required: true, message: '请选择结束时间', trigger: 'blur' },
                ],
            }
        };
    },
    created() {
        this.getTitleQuota()
        this.getTree()
        this.getSchoolList()
    },
    mounted() {

    },

    methods: {
        // 导出表格
        export2Excel(val) {
            val.grossSales = ((val.ownGoods * 100) + (val.transportation * 100)) / 100
            // console.log(val);
            // return
            require.ensure([], () => {
                this.$message.success('导出中')
                const { export_json_to_excel } = require("../excel/Export2Excel");
                const tHeader = ['学校名称', '自有商品数量', '自有商品销售额', '物流费用', '总流水']; // 设置Excel的表格第一行的标题
                const filterVal = ["schoolName", "ownGoodsCount", "ownGoods", "transportation", "grossSales"]; // 对象tableData中一个对象的属性
                const list = [val]; //把data里的tableData存到list
                const data = this.formatJson(filterVal, list); //对数据过滤
                const head = val.schoolName + '商品销售量统计';
                // tHeader：第一行标题； data:要显示的数据；head：下载的文件名
                export_json_to_excel(tHeader, data, head);
            });
        },
        // 数据过滤
        formatJson(filterVal, jsonData) {
            return jsonData.map((v) => filterVal.map((j) => v[j]));
        },
        // 获取销售额指标
        async getTitleQuota() {
            const res = await request({
                method: 'GET',
                url: `admin/statistical/analysis/getTitleQuota/statistics?timeSectionState=${this.timeSectionState}`
            })
            if (res.code === '200') {
                this.statisticsData = res.data
            } else {
                this.$message.error(res.message)
            }
        },
        // 重置查询
        resetList() {
            console.log(1);
            this.info.province = null
            this.info.city = null
            this.info.area = null
            this.info.isPage = true
            this.info.pageSize = 10
            this.info.pageNum = 1
            this.info.schoolName = ''
            this.info.detailedArea = []
            this.getSchoolList()
        },
        // 地区树状图
        async getTree() {
            const res = await request({
                method: "POST",
                url: 'admin/school/tree'
            })
            if (res.code === '200') {
                this.options = res.data
            } else {
                this.$message.error(res.message)
            }
        },
        // 获取学校列表
        async getSchoolList() {
            const res = await request({
                method: 'POST',
                url: 'admin/statistical/analysis/get/school/list',
                data: this.info
            })
            if (res.code === '200') {
                this.tableData = res.data && res.data.list
                this.totalPage = res.data && res.data.total
            } else {
                this.$message.error(res.message)
            }
        },
        // 计算销售总额
        totalCalculation(item) {
            return ((Number(item.ownGoods) * 100) - (Number(item.transportation) * 100)) / 100
        },
        // 分页
        handleCurrentChange() {
            this.getSchoolList()
        },
        // 详情
        editorChild(val) {
            this.$router.push({ name: 'statisticalBatch', query: { id: val.id } })
        },
        // 搜索
        search() {
            this.info.pageNum = 1
            this.getSchoolList()
        },
        // 打开导出弹窗
        openFinancial() {
            this.infoExpoit.startTime = null
            this.infoExpoit.endTime = null
            this.dialogRefundExpoit = true
        },
        // 财务导出
        financialExport() {
            this.$refs['infoExpoit'].validate((valid) => {
                if (valid) {
                    axios({
                        method: 'POST',
                        url: exportUrl + 'order/export/finance',
                        headers: {
                            'Authorization': 'Bearer ' + sessionStorage.getItem('authorization'),
                            'Content-Type': 'application/json;charset=utf-8'
                        },
                        data: this.infoExpoit,
                        responseType: 'blob'
                    }).then((res) => {
                        this.dialogRefundExpoit = false
                        const temp = res.headers['content-disposition'].split(";")[1].split("filename=")[1];
                        let blob = new Blob([res.data], { type: 'application/vnd.ms-excel' }) // res就是接口返回的文件流了
                        let objectUrl = URL.createObjectURL(blob)
                        const a = document.createElement('a')
                        a.download = decodeURIComponent(temp)  //后缀名一定要写对，不然会导致文件损坏，打不开
                        a.href = objectUrl
                        a.click()
                        a.remove()


                    }).catch(error => {
                        this.dialogRefundExpoit = false
                        console.log(error);
                        this.$message.error("错误")
                    });
                } else {
                    return false;
                }
            });
        },
        // 负责人
        openInChargen() {
            this.$router.push({ name: 'inChargeManagement'})
        }
    },
    watch: {
        'info.detailedArea'(newItem) {
            // console.log(item1,'000',item2);
            console.log(newItem);
            if (newItem.length >= 3) {
                this.info.province = newItem[0]
                this.info.city = newItem[1]
                this.info.area = newItem[2]

            } else if (newItem.length >= 2 && newItem.length < 3) {
                this.info.province = newItem[0]
                this.info.city = newItem[1]
                this.info.area = null
            } else if (newItem.length >= 1 && newItem.length < 2) {
                this.info.province = newItem[0]
                this.info.city = null
                this.info.area = null
            } else {
                this.info.province = null
                this.info.city = null
                this.info.area = null
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.list {
    background-color: #2589ff;
    color: #fff;
    text-align: center;
    width: 106px;
    height: 36px;
    margin-right: 10px;
    font-size: 16px;
    line-height: 36px;
    display: inline-block;
    border-radius: 6px;
}

.content {
    margin: 20px 0 0 0;
    background-color: #e0e0e0;
    padding: 10px;
    border-radius: 5px;
}

.goods {
    background-color: #fff;
    border-radius: 5px;
    padding: 10px 20px;
}

.gross-container {
    width: 300px;
    height: 100px;
    background-color: #000;
    text-align: center;
    padding: 20px 0;
    color: #fff;
}

.condition {
    display: flex;
    line-height: 30px;
}

.herd {
    display: flex;
    justify-content: space-between;
}

.block {
    text-align: right;
    background-color: #fff;
}

// .global-table-box{
//     height: 200px;
//     overflow: hidden;
// }

.el-select .el-input {
    width: 130px;
}

.input-with-select .el-input-group__prepend {
    background-color: #fff;
}
</style>